var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from 'react';
import { signOut, onAuthStateChanged, getIdToken, browserLocalPersistence, setPersistence } from 'firebase/auth';
import { auth } from '../config/firebase';
var AuthContext = createContext(null);
export var useAuth = function () {
    var context = useContext(AuthContext);
    if (!context)
        throw new Error('useAuth must be used within an AuthProvider');
    return context;
};
export var AuthProvider = function (_a) {
    var children = _a.children;
    var _b = useState(null), currentUser = _b[0], setCurrentUser = _b[1];
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    var _d = useState(null), error = _d[0], setError = _d[1];
    var _e = useState(null), token = _e[0], setToken = _e[1];
    // Set persistence to LOCAL
    useEffect(function () {
        setPersistence(auth, browserLocalPersistence)
            .then(function () {
            console.log('Successfully set persistence to LOCAL');
        })
            .catch(function (error) {
            console.error('Error setting persistence:', error);
        });
    }, []);
    // Handle auth state changes
    useEffect(function () {
        console.log('Setting up auth state listener...');
        var unsubscribe = onAuthStateChanged(auth, function (user) { return __awaiter(void 0, void 0, void 0, function () {
            var idToken, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('Auth state changed:', user ? "User ".concat(user.email, " logged in") : 'No user');
                        if (!user) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, getIdToken(user, true)];
                    case 2:
                        idToken = _a.sent();
                        setToken(idToken);
                        console.log('Got token for user:', user.email);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error('Error getting token:', error_1);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        setToken(null);
                        _a.label = 6;
                    case 6:
                        setCurrentUser(user);
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        }); }, function (err) {
            console.error('Auth state error:', err);
            setError(err);
            setLoading(false);
        });
        return function () { return unsubscribe(); };
    }, []);
    var logout = function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_1, authError;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    setError(null);
                    return [4 /*yield*/, signOut(auth)];
                case 1:
                    _a.sent();
                    setToken(null);
                    console.log('Successfully logged out');
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    authError = err_1;
                    console.error('Sign out error:', authError);
                    setError(authError);
                    throw authError;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var clearError = function () { return setError(null); };
    return (_jsx(AuthContext.Provider, { value: { currentUser: currentUser, loading: loading, error: error, token: token, logout: logout, clearError: clearError }, children: children }));
};
